import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Storage from '../utils/storageES.js'
import HomeButton from './HomeButton.jsx'

function Groceries({ userData, onNavigate, embedded = false }) {
  const { t } = useTranslation()
  const [checklist, setChecklist] = useState([])
  const [newItem, setNewItem] = useState('')
  const [isAddingItem, setIsAddingItem] = useState(false)

  // Default grocery items - stores translation keys, not translated text
    const getDefaultItems = () => [
      // Fruits & Vegetables
      { id: 'produce1', nameKey: 'groceries.items.bananas', categoryKey: 'groceries.categories.produce',     
  checked: false },
      { id: 'produce2', nameKey: 'groceries.items.apples', categoryKey: 'groceries.categories.produce',      
  checked: false },
      { id: 'produce3', nameKey: 'groceries.items.oranges', categoryKey: 'groceries.categories.produce',     
  checked: false },
      { id: 'produce4', nameKey: 'groceries.items.lettuce', categoryKey: 'groceries.categories.produce',     
  checked: false },
      { id: 'produce5', nameKey: 'groceries.items.tomatoes', categoryKey: 'groceries.categories.produce',    
   checked: false },
      { id: 'produce6', nameKey: 'groceries.items.onions', categoryKey: 'groceries.categories.produce',      
  checked: false },
      { id: 'produce7', nameKey: 'groceries.items.carrots', categoryKey: 'groceries.categories.produce',     
  checked: false },
      { id: 'produce8', nameKey: 'groceries.items.potatoes', categoryKey: 'groceries.categories.produce',    
   checked: false },

      // Dairy & Eggs
      { id: 'dairy1', nameKey: 'groceries.items.milk', categoryKey: 'groceries.categories.dairy',
  checked: false },
      { id: 'dairy2', nameKey: 'groceries.items.eggs', categoryKey: 'groceries.categories.dairy',
  checked: false },
      { id: 'dairy3', nameKey: 'groceries.items.butter', categoryKey: 'groceries.categories.dairy',
  checked: false },
      { id: 'dairy4', nameKey: 'groceries.items.cheese', categoryKey: 'groceries.categories.dairy',
  checked: false },
      { id: 'dairy5', nameKey: 'groceries.items.yogurt', categoryKey: 'groceries.categories.dairy',
  checked: false },

      // Meat & Seafood
      { id: 'protein1', nameKey: 'groceries.items.chicken', categoryKey: 'groceries.categories.protein',     
  checked: false },
      { id: 'protein2', nameKey: 'groceries.items.beef', categoryKey: 'groceries.categories.protein',        
  checked: false },
      { id: 'protein3', nameKey: 'groceries.items.fish', categoryKey: 'groceries.categories.protein',        
  checked: false },
      { id: 'protein4', nameKey: 'groceries.items.deliMeat', categoryKey: 'groceries.categories.protein',    
   checked: false },

      // Pantry Staples
      { id: 'pantry1', nameKey: 'groceries.items.bread', categoryKey: 'groceries.categories.pantry',
  checked: false },
      { id: 'pantry2', nameKey: 'groceries.items.rice', categoryKey: 'groceries.categories.pantry',
  checked: false },
      { id: 'pantry3', nameKey: 'groceries.items.pasta', categoryKey: 'groceries.categories.pantry',
  checked: false },
      { id: 'pantry4', nameKey: 'groceries.items.oliveOil', categoryKey: 'groceries.categories.pantry',      
  checked: false },
      { id: 'pantry5', nameKey: 'groceries.items.salt', categoryKey: 'groceries.categories.pantry',
  checked: false },
      { id: 'pantry6', nameKey: 'groceries.items.pepper', categoryKey: 'groceries.categories.pantry',        
  checked: false },
      { id: 'pantry7', nameKey: 'groceries.items.garlic', categoryKey: 'groceries.categories.pantry',        
  checked: false },
      { id: 'pantry8', nameKey: 'groceries.items.cannedTomatoes', categoryKey:
  'groceries.categories.pantry', checked: false },

      // Beverages
      { id: 'drinks1', nameKey: 'groceries.items.water', categoryKey: 'groceries.categories.beverages',      
  checked: false },
      { id: 'drinks2', nameKey: 'groceries.items.coffee', categoryKey: 'groceries.categories.beverages',     
  checked: false },
      { id: 'drinks3', nameKey: 'groceries.items.tea', categoryKey: 'groceries.categories.beverages',        
  checked: false },
      { id: 'drinks4', nameKey: 'groceries.items.orangeJuice', categoryKey:
  'groceries.categories.beverages', checked: false },
      { id: 'drinks5', nameKey: 'groceries.items.wineBeer', categoryKey:
  'groceries.categories.beverages', checked: false },

      // Snacks & Sweets
      { id: 'snacks1', nameKey: 'groceries.items.crackers', categoryKey: 'groceries.categories.snacks',      
  checked: false },
      { id: 'snacks2', nameKey: 'groceries.items.nuts', categoryKey: 'groceries.categories.snacks',
  checked: false },
      { id: 'snacks3', nameKey: 'groceries.items.chocolate', categoryKey: 'groceries.categories.snacks',     
  checked: false },
      { id: 'snacks4', nameKey: 'groceries.items.cookies', categoryKey: 'groceries.categories.snacks',       
  checked: false },
      { id: 'snacks5', nameKey: 'groceries.items.chips', categoryKey: 'groceries.categories.snacks',
  checked: false },

      // Frozen Foods
      { id: 'frozen1', nameKey: 'groceries.items.iceCream', categoryKey: 'groceries.categories.frozen',      
  checked: false },
      { id: 'frozen2', nameKey: 'groceries.items.frozenVegetables', categoryKey:
  'groceries.categories.frozen', checked: false },
      { id: 'frozen3', nameKey: 'groceries.items.frozenPizza', categoryKey:
  'groceries.categories.frozen', checked: false },

      // Personal Care
      { id: 'personal1', nameKey: 'groceries.items.toiletPaper', categoryKey:
  'groceries.categories.personalCare', checked: false },
      { id: 'personal2', nameKey: 'groceries.items.shampoo', categoryKey:
  'groceries.categories.personalCare', checked: false },
      { id: 'personal3', nameKey: 'groceries.items.toothpaste', categoryKey:
  'groceries.categories.personalCare', checked: false },
      { id: 'personal4', nameKey: 'groceries.items.soap', categoryKey:
  'groceries.categories.personalCare', checked: false }
    ]

  useEffect(() => {
    loadChecklist()
  }, [])

  const loadChecklist = () => {
    const tripData = Storage.getTripData()
    const savedGroceries = tripData.groceries || []

    if (savedGroceries.length === 0) {
      // First time - initialize with default items
      const defaultItems = getDefaultItems()
      setChecklist(defaultItems)
      saveGroceries(defaultItems)
    } else {
      setChecklist(savedGroceries)
    }
  }

  const saveGroceries = (items) => {
    const tripData = Storage.getTripData()
    tripData.groceries = items
    Storage.saveTripData(tripData)
  }

  const toggleItem = (id) => {
    const updatedChecklist = checklist.map(item =>
      item.id === id ? { ...item, checked: !item.checked } : item
    )
    setChecklist(updatedChecklist)
    saveGroceries(updatedChecklist)
  }

const addCustomItem = () => {
      if (!newItem.trim()) return

      const customItem = {
        id: `custom_${Date.now()}`,
        name: newItem.trim(),
        categoryKey: 'groceries.customCategory',
        checked: false
      }

    const updatedChecklist = [...checklist, customItem]
    setChecklist(updatedChecklist)
    saveGroceries(updatedChecklist)
    setNewItem('')
    setIsAddingItem(false)
  }

  const removeItem = (id) => {
    const updatedChecklist = checklist.filter(item => item.id !== id)
    setChecklist(updatedChecklist)
    saveGroceries(updatedChecklist)
  }

  const clearCompleted = () => {
    const updatedChecklist = checklist.map(item => ({ ...item, checked: false }))
    setChecklist(updatedChecklist)
    saveGroceries(updatedChecklist)
  }

 // Group items by category, translating category keys
    const groupedItems = checklist.reduce((acc, item) => {
      const category = item.categoryKey ? t(item.categoryKey) : item.category
      if (!acc[category]) acc[category] = []
      acc[category].push(item)
      return acc
    }, {})

  const getProgress = () => {
    const total = checklist.length
    const checked = checklist.filter(item => item.checked).length
    return { checked, total, percentage: total > 0 ? Math.round((checked / total) * 100) : 0 }
  }

  const progress = getProgress()

  const content = (
    <>
      {/* Header */}
      {!embedded && <div style={{
        textAlign: 'center',
        marginBottom: '30px',
        paddingTop: '60px'
      }}>
        <h1 style={{
          fontSize: '36px',
          fontWeight: '900',
          color: '#8B7355',
          margin: '0 0 8px 0',
          letterSpacing: '2px',
          fontFamily: "'Noto Serif', serif",
          textTransform: 'uppercase'
        }}>{t('groceries.title')}</h1>
        <p style={{
          fontSize: '14px',
          color: '#8B7355',
          margin: '0 0 16px 0',
          opacity: '0.7'
        }}>{userData.destination?.toUpperCase() || t('groceries.yourShopping')}</p>
        
        {/* Progress Bar */}
        <div style={{
          background: 'white',
          borderRadius: '25px',
          padding: '12px 20px',
          margin: '0 auto 16px auto',
          maxWidth: '300px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            fontSize: '14px',
            fontWeight: '600',
            color: '#B8A082',
            marginBottom: '8px'
          }}>
            {t('groceries.itemsCollected', { checked: progress.checked, total: progress.total, percentage: progress.percentage })}
          </div>
          <div style={{
            background: '#ede4d3',
            height: '8px',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            <div style={{
              background: '#C4714A',
              height: '100%',
              width: `${progress.percentage}%`,
              borderRadius: '4px',
              transition: 'width 0.3s ease'
            }}></div>
          </div>
        </div>
      </div>}

      {/* Control Buttons */}
      <div style={{
        display: 'flex',
        gap: '8px',
        marginBottom: '20px'
      }}>
        {!isAddingItem ? (
          <button
            onClick={() => setIsAddingItem(true)}
            style={{
              background: '#C4714A',
              color: 'white',
              border: 'none',
              padding: '12px 16px',
              borderRadius: '25px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              flex: '1'
            }}
          >
            {t('groceries.addItem')}
          </button>
        ) : (
          <div style={{ 
            background: 'white',
            borderRadius: '16px',
            padding: '16px',
            flex: '1',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <input
                type="text"
                value={newItem}
                onChange={(e) => setNewItem(e.target.value)}
                placeholder={t('groceries.placeholderItem')}
                style={{
                  flex: '1',
                  padding: '10px 14px',
                  border: '2px solid #ede4d3',
                  borderRadius: '20px',
                  fontSize: '14px',
                  outline: 'none'
                }}
                onKeyPress={(e) => e.key === 'Enter' && addCustomItem()}
                autoFocus
              />
              <button
                onClick={addCustomItem}
                style={{
                  background: '#C4714A',
                  color: 'white',
                  border: 'none',
                  padding: '10px 16px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                {t('buttons.add')}
              </button>
              <button
                onClick={() => {
                  setIsAddingItem(false)
                  setNewItem('')
                }}
                style={{
                  background: '#ccc',
                  color: 'white',
                  border: 'none',
                  padding: '10px 16px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  cursor: 'pointer'
                }}
              >
                {t('buttons.cancel')}
              </button>
            </div>
          </div>
        )}
        
        {progress.checked > 0 && (
          <button
            onClick={clearCompleted}
            style={{
              background: '#8B7355',
              color: 'white',
              border: 'none',
              padding: '12px 16px',
              borderRadius: '25px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            {t('groceries.clearAll')}
          </button>
        )}
      </div>

      {/* Checklist by Category */}
      {Object.entries(groupedItems).map(([category, items]) => (
        <div key={category} style={{
          background: 'white',
          borderRadius: '16px',
          padding: '20px',
          margin: '0 0 16px 0',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '700',
            color: '#B8A082',
            margin: '0 0 16px 0',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>{category}</h3>
          
          {items.map(item => (
            <div key={item.id} style={{
              display: 'flex',
              alignItems: 'center',
              padding: '10px 0',
              borderBottom: '1px solid #f5f5f5'
            }}>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                flex: '1',
                cursor: 'pointer',
                fontSize: '14px',
                color: item.checked ? '#999' : '#333'
              }}>
                <input
                  type="checkbox"
                  checked={item.checked}
                  onChange={() => toggleItem(item.id)}
                  style={{
                    width: '18px',
                    height: '18px',
                    marginRight: '12px',
                    accentColor: '#C4714A'
                  }}
                />
                  <span style={{
                  textDecoration: item.checked ? 'line-through' : 'none'
                  }}>
                    {item.nameKey ? t(item.nameKey) : item.name}
                  </span>
                {item.checked && (
                  <span style={{
                    marginLeft: '8px',
                    color: '#B8A082',
                    fontSize: '12px'
                  }}>✓</span>
                )}
              </label>


               {(item.categoryKey === 'groceries.customCategory' || item.category ===
  t('groceries.customCategory')) && (
                <button
                  onClick={() => removeItem(item.id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#ccc',
                    fontSize: '16px',
                    cursor: 'pointer',
                    padding: '4px'
                  }}
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
      ))}

      {/* Back Button */}
      {!embedded && <div style={{ textAlign: 'center', margin: '20px 0' }}>
        <button
          style={{
            background: 'transparent',
            color: '#8B7355',
            border: '2px solid #8B7355',
            padding: '12px 24px',
            borderRadius: '25px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
          onClick={() => onNavigate('home')}
        >
          {t('navigation.backToHome')}
        </button>
      </div>}
    </>
  )

  if (embedded) return content

  return (
    <div className="container groceries-checklist" style={{
      background: 'linear-gradient(135deg, #f5f1eb 0%, #ede4d3 100%)',
      minHeight: '100vh',
      padding: '20px',
      position: 'relative'
    }}>
      <HomeButton onNavigate={onNavigate} />
      {content}
    </div>
  )
}

export default Groceries